// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MbM2","right":"styles_right__YCUe5"};